export default __webpack_public_path__ + "static/media/happy-woman.4176342c.svg";